import { PO_SHIPMENT_STATUS_COLORS } from '../../../utils/config/shipmentStatusColors';

const EventLegend = () => {
  return (
    <div style={{ display: "flex", gap: "15px", marginBottom: "10px", flexWrap: "wrap" }}>
      {Object.entries(PO_SHIPMENT_STATUS_COLORS).map(([label, color]) => (
        <div key={label} style={{ display: "flex", alignItems: "center" }}>
          <span
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: color,
              display: "inline-block",
              marginRight: "5px",
              borderRadius: "3px",
            }}
          />
          {label}
        </div>
      ))}
    </div>
  );
};

export default EventLegend